module.exports = __webpack_public_path__ + "img/close.ef505bfb.png";